// API Client - Axios instance with base configuration
import axios from 'axios';
import type { ApiResponse } from './types';

const API_BASE_URL = '/api/v1';

// Create axios instance with defaults
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Include cookies for session auth
});

// Request interceptor for adding auth token if available
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Let axios auto-set Content-Type for FormData (multipart/form-data with boundary)
  // Check using multiple methods for browser compatibility
  const isFormData = config.data instanceof FormData || 
    (config.data && typeof config.data.append === 'function' && 
     config.data.toString() === '[object FormData]');
  
  if (isFormData) {
    // Must delete to let browser set multipart boundary correctly
    delete config.headers['Content-Type'];
  }
  
  return config;
});

// Response interceptor for handling errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth state on 401
      localStorage.removeItem('auth_token');
    }
    return Promise.reject(error);
  }
);

// Helper to extract data from response
export function unwrapResponse<T>(response: { data: ApiResponse<T> }): T {
  if (response.data.ok) {
    return response.data.data;
  }
  throw new Error(response.data.error.message);
}

export default apiClient;
